import { combineReducers } from 'redux';
import cart from './cart';
import errors from './error';
import request from './request';

const reducer = combineReducers({
    cart,
    errors,
    request,
});

export default reducer;
